var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef } from 'react';
import styled from 'styled-components';
import { getGeometryStyle, getMinimumHeight, getMinimumWidth, getMaximumHeight, getHeightWidth, getMaximumWidth, } from '../../helpers/styles';
import useRadioFormItem from '../../hooks/useRadioFormItem';
import Image from '../Image';
var getMinHeightWidth = function (minimumSize) {
    return "\n  min-height: " + getMinimumHeight(minimumSize) + ";\n  min-width: " + getMinimumWidth(minimumSize) + ";";
};
var getMaxHeightWidth = function (maximumSize) {
    return "\n  max-height: " + getMaximumHeight(maximumSize) + ";\n  max-width: " + getMaximumWidth(maximumSize) + ";";
};
var StyledButton = styled.button.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  ", "\n  color: ", ";\n  border: ", ";\n  background: ", ";\n  outline: ", ";\n  box-sizing: ", ";\n  border-radius: ", ";\n  cursor: ", ";\n  font-family: ", ";\n  background-color: ", ";\n  :focus {\n    outline: ", ";\n  }\n  :active {\n    border-left-color: ", ";\n    border-top-color: ", ";\n    border-right-color: ", ";\n    border-bottom-color: ", ";\n  }\n  :hover {\n    background-color: ", ";\n  }\n  ", "\n    } \n"], ["\n  ", "\n  ",
    "\n  ", "\n  ", "\n  color: ", ";\n  border: ", ";\n  background: ", ";\n  outline: ", ";\n  box-sizing: ", ";\n  border-radius: ", ";\n  cursor: ", ";\n  font-family: ", ";\n  background-color: ", ";\n  :focus {\n    outline: ", ";\n  }\n  :active {\n    border-left-color: ",
    ";\n    border-top-color: ",
    ";\n    border-right-color: ",
    ";\n    border-bottom-color: ",
    ";\n  }\n  :hover {\n    background-color: ",
    ";\n  }\n  ",
    "\n    } \n"])), function (_a) {
    var geometry = _a.geometry;
    return getGeometryStyle(geometry);
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return getHeightWidth(windowTheme.button.width, windowTheme.button.height);
}, function (_a) {
    var minimumSize = _a.minimumSize;
    return minimumSize && getMinHeightWidth(minimumSize);
}, function (_a) {
    var maximumSize = _a.maximumSize;
    return maximumSize && getMaxHeightWidth(maximumSize);
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.color;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.border;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.background;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.outline;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.boxSizing;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.borderRadius;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.cursor;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.fontFamily;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.backgroundColor;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.focus.outline;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.active.borderColor.left;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.active.borderColor.top;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.active.borderColor.right;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.active.borderColor.bottom;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.hover.backgroundColor;
}, function (_a) {
    var active = _a.active, windowTheme = _a.windowTheme;
    return active
        ? "border-left-color: \n          " + windowTheme.button.active.borderColor.left + ";\n    border-top-color: \n      " + windowTheme.button.active.borderColor.top + ";\n    border-right-color: " + windowTheme.button.active.borderColor.right + ";\n    border-bottom-color: " + windowTheme.button.active.borderColor.bottom + ";"
        : "border-left-color: " + windowTheme.button.borderColor.left + ";\n    border-top-color: " + windowTheme.button.borderColor.top + ";\n    border-right-color: " + windowTheme.button.borderColor.right + ";\n    border-bottom-color: " + windowTheme.button.borderColor.bottom + ";";
});
var StyledInput = styled.input.attrs(function (props) { })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  min-width: ", ";\n"], ["\n  min-width: ", ";\n"])), function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.radio.input.minWidth;
});
var ToggleTabButton = function (props) {
    var _a;
    var attributes = props.attributes, identifier = props.identifier, parentWidget = props.parentWidget, type = props.type, children = props.children, parentIdentifier = props.parentIdentifier, className = props.className, restProps = __rest(props, ["attributes", "identifier", "parentWidget", "type", "children", "parentIdentifier", "className"]), text = attributes.text, geometry = attributes.geometry, checked = attributes.checked, minimumSize = attributes.minimumSize, maximumSize = attributes.maximumSize, enabled = attributes.enabled, restAttributes = __rest(attributes, ["text", "geometry", "checked", "minimumSize", "maximumSize", "enabled"]);
    var inputElement = useRef(null);
    var handleClick = function (evt) {
        inputElement.current.click();
    };
    var formItemProps = useRadioFormItem(identifier, parentWidget, function (evt) { return evt.target.checked; });
    var selected = formItemProps.value[identifier] || false;
    var iconSize = attributes.iconSize;
    return (React.createElement("div", null,
        React.createElement(StyledInput, __assign({ ref: inputElement }, restProps, restAttributes, { type: "radio", id: identifier, style: { display: 'none' }, name: parentIdentifier }, formItemProps, { checked: selected })),
        React.createElement(StyledButton, __assign({ active: selected, id: identifier, "data-widget-type": type, geometry: geometry }, restProps, { onClick: handleClick, minimumSize: minimumSize, maximumSize: maximumSize, disabled: (enabled && enabled === 'false') || false }), ((_a = attributes === null || attributes === void 0 ? void 0 : attributes.icon) === null || _a === void 0 ? void 0 : _a.normalon) ? (React.createElement(Image, { width: iconSize.width, height: iconSize.height, imageName: attributes.icon.normalon })) : ("" + text))));
};
export default ToggleTabButton;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map